function OrganizationUsersCtrl(OrganizationService, $state, $stateParams, AppSettings, $rootScope, CommonService, AdminService, $scope, toaster, ConnectionService) {
  'ngInject';

  const vm = this;
  vm.orgId = !$stateParams.orgId ? '' : $stateParams.orgId;
  vm.inviteFlag = false;
  vm.assignFlag = false;
  vm.addUserForm = {};
  vm.name = !$stateParams.name ? '' : $stateParams.name;
  vm.email = !$stateParams.email ? '' : $stateParams.email;
  vm.company = !$stateParams.company ? '' : $stateParams.company;
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.userAssign = {};
  vm.loading = false;
  vm.userloading = false;
  vm.urlParams = {
    email: vm.email,
    pageNumber: '',
    size: '',
    name: vm.name,
    company: vm.company,
    sortBy: vm.sortBy
  };

  vm.init = function () {
    //to hide the organization name
    $rootScope.organizationNameView = false;
    vm.loading = true;
    OrganizationService.getAssignedUsers(vm.orgId, function (response) {
      vm.loading = false;
      if (response.status == 200) {
        vm.users = response.data.users;
      }
    });
  };

  vm.search = function (name, email, company) {
    $state.go('user.organizations.userList', { name: name, email: email, company: company });
  };

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.organizations.userList', {sortBy: param});
  };

  vm.inviteUser = function () {
    vm.inviteFlag = true;
    vm.assignFlag = false;
  };

  vm.saveAndInviteUser = function () {
    vm.userloading = true;
    vm.addUserForm['organization_id'] = vm.orgId;
    AdminService.newUser(vm.addUserForm, function (response) {
      if (response.data.errors) {
        toaster.pop('error', response.data.errors[0]);
      }
      else if (response.data.success) {
        vm.inviteFlag = false;
        toaster.pop('info', response.data.success[0]);
      } else {
        toaster.pop('error', 'Unable to invite user to the organization.');
      }
      vm.userloading = false;
    });
  };

  vm.closeInviteForm = function () {
    vm.addUserForm = {};
    vm.inviteFlag = false;
  };

  vm.assignUser = function () {
    vm.assignFlag = true;
    vm.inviteFlag = false;
  };

  vm.closeAssignForm = function () {
    vm.assignFlag = false;
  };

  vm.updateUserListByEmail = function (email) {
    if (email.length >= 0) {
      vm.urlParams.email = email;
      vm.urlParams.name = '';
      vm.urlParams.company = '';
      vm.urlParams. sortBy = 'email';
      AdminService.listUsers(vm.urlParams, function (response) {
        if (response.status == 200) {
          vm.usersForEmails = response.data.users;
        }
      });
    }
  };

  vm.addExistingUser = function () {
    if (!vm.userAssign.id) {
      toaster.pop('info', 'No user selected!');
    } else {
      vm.userloading = true;
      OrganizationService.assignUserToOrganization(vm.orgId, vm.userAssign.id, function (resp) {
        if (resp && resp.data && resp.data.status == 'success') {
          vm.assignFlag = false;
          vm.init();
          toaster.pop('info', 'Successfully assigned User to organization.');
        } else if (resp.data.errors) {
          toaster.pop('error', resp.data.errors[0]);
        } else {
          toaster.pop('error', 'Unable to assign user to the organization.');
        }
        vm.userloading = false;
      });
    }
  };

  vm.statusChange = function (user) {
    OrganizationService.updateStatus(vm.orgId, user.id, user.user_status, function (response) {
      if (response.status >= 200 && response.status < 300) {
        toaster.pop('info', 'User status changed successfully.');
      } else {
        toaster.pop('error', 'Unable to change user status.');
      }
    });
  };

  vm.tooltipStatus = function (status) {
    if(status){
      return 'Disable';
    }else{
      return 'Enable';
    }
  };
}
export default {
  name: 'OrganizationUsersCtrl',
  fn: OrganizationUsersCtrl
};